<template>
  <div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업기간</span></label>
      <div class="col-4 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          :value="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          @change="(val) => { permit.workPeriod = val; }"
          style="font-size: 12px;" input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>화기작업 종류</span></label>
      <div class="col-10 pt-2">
        <label class="md-check mr-20" v-for="t in fireWorkTypes" :key="t">
          <input type="checkbox" v-model="permit.workTypes" :value="t">
          <i class="blue"></i>{{ t }}
        </label>
        <label class="md-check mr-10">
          <input type="checkbox" v-model="permit.isOther">
          <i class="blue"></i>기타 화기작업
        </label>
        <input v-if="permit.isOther" type="text" class="form-control mt-5"
               v-model="permit.otherText" placeholder="기타 화기작업 내용 입력 (필수)"
               :style="{ maxWidth:'300px', ...((permit.otherText || '').trim() ? {} : { borderColor:'#eb5757' }) }">
        <div v-if="permit.isOther && !(permit.otherText || '').trim()"
             style="color:#eb5757; font-size:11px; margin-top:4px;">기타 화기작업 내용은 필수 입력입니다.</div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">화재감시자</span></label>
      <div class="col-4 pt-2">
        <input type="text" class="form-control" v-model="permit.fireWatcher" placeholder="성명 입력 (필수)"
               :style="(permit.fireWatcher || '').trim() ? {} : { borderColor:'#eb5757' }">
        <div v-if="!(permit.fireWatcher || '').trim()" style="color:#eb5757; font-size:11px; margin-top:4px;">
          화재감시자는 필수 입력입니다.
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">화재감시자 연락처</span></label>
      <div class="col-4 pt-2">
        <input type="text" class="form-control"
          :class="{ 'is-invalid': permit.fireWatcherPhone && !isValidPhone(permit.fireWatcherPhone) }"
          :style="(permit.fireWatcherPhone || '').trim() ? {} : { borderColor:'#eb5757' }"
          :value="permit.fireWatcherPhone"
          @input="permit.fireWatcherPhone = formatPhone($event.target.value)"
          placeholder="010-0000-0000 (필수)">
        <div v-if="permit.fireWatcherPhone && !isValidPhone(permit.fireWatcherPhone)" class="invalid-feedback">
          올바른 전화번호 형식이 아닙니다.
        </div>
        <div v-else-if="!(permit.fireWatcherPhone || '').trim()" style="color:#eb5757; font-size:11px; margin-top:4px;">
          화재감시자 연락처는 필수 입력입니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FireWorkPermit',
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    }
  },
  data() {
    return {
      fireWorkTypes: ['용접', '용단(가스절단, 플라즈마 절단 등)', '연마(그라인더 등)', '드릴', '절단톱']
    }
  },
  methods: {
    formatPhone(value) {
      const digits = value.replace(/\D/g, '');
      if (digits.length <= 3) return digits;
      if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
      return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
    },
    isValidPhone(value) {
      return /^0\d{1,2}-\d{3,4}-\d{4}$/.test(value);
    }
  }
}
</script>